import { useList, useDetail, useCreate, useUpdate, fetchApi, useDelete } from "@inmagik/react-crud"
import { Edizione } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useEdizioniList(params: Record<string, string> = {}) {
  return useList<Edizione>(`${API_URL}/admin/edizioni`, {
    query: params,
  })
}

export function useEdizione(id: number | undefined) {
  return useDetail<Edizione>(`${API_URL}/admin/edizioni`, id?.toString())
}

export function useEdizioneCreate() {
  return useCreate<Edizione>(`${API_URL}/admin/edizioni`)
}

export function useEdizioneUpdate() {
  return useUpdate<Edizione>(`${API_URL}/admin/edizioni`)
}

export function useEdizioneLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/edizioni/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Edizione>
  }, [])
}

export function useEdizioniLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/edizioni?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Edizione[] }>
  }, [])
}

export function useEdizioneDelete() {
  return useDelete(`${API_URL}/admin/edizioni`)
}




